import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuthStore } from '@/lib/auth/store';
import { InboundComposeWizard } from '../components/InboundComposeWizard';
import { useComposeInboundCampaign } from '../api';
import { buildInboundComposeRequest } from '../payload';
import { DEFAULT_INBOUND_FORM_VALUES } from '../types';

export function AddInboundCampaignPage() {
  const navigate = useNavigate();
  const userId = useAuthStore((s) => s.userId);
  const compose = useComposeInboundCampaign();

  return (
    <InboundComposeWizard
      mode="create"
      initialValues={DEFAULT_INBOUND_FORM_VALUES}
      isPending={compose.isPending}
      onSubmit={(values) => {
        compose.mutate(
          buildInboundComposeRequest({ userId: Number(userId), values }),
          {
            onSuccess: (res) => {
              if (res?.message === 'Parameters Incorrect') {
                toast.error(res.message);
                return;
              }
              toast.success(res?.message ?? 'Inbound campaign created');
              navigate('/inbound-campaign-list');
            },
            onError: () => toast.error('Could not create the inbound campaign.'),
          },
        );
      }}
    />
  );
}
